import {
  makeStyles,
  Theme,
  createStyles,
  Grid,
  Paper,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  Backdrop,
  Fade,
  Modal,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Box,
  InputAdornment,
  IconButton,
  Input,
} from "@material-ui/core";
import DataService from "../../Service";

import React, { HtmlHTMLAttributes, useCallback, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
// import { Post_API } from "../../Service/service";
import { api_url } from "../../constants";
import CustomInput from "../../Components/CustomInput";
import { Link, useHistory } from "react-router-dom";
import { green } from "@material-ui/core/colors";
import { useDispatch, useSelector } from "react-redux";
import {
  GLOBAL_DATA,
  ACCESS_PERMISSION,
  DELETE_DATA,
} from "../../Redux/actions";
import AuthClient from "../../Service/auth_services";
import { showSnackbar } from "../../Components/Snackbar/SnackbarActions";
import logo from "../../Images/aimio-logo.png";
import { useParams } from "react-router";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {
  useLastLocation,
  WithLastLocationProps,
} from "react-router-last-location";
import { fetchLevelAccess } from "../../Common/constant";
import { queryClient } from "../..";
var CryptoJS = require("crypto-js");

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalroot: {
      height: 300,
      flexGrow: 1,
      minWidth: 600,
      transform: "translateZ(0)",
      // The position fixed scoping doesn't work in IE 11.
      // Disable this demo to preserve the others.
      "@media all and (-ms-high-contrast: none)": {
        display: "none",
      },
    },
    textSecondary: {
      color: theme.palette.secondary.main,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 20,
    },
    paper: {
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      padding: 20,

      textAlign: "left",
    },
    modalInner: {
      width: 600,
      borderRadius: 10,
      maxHeight: 500,
      overflow: "auto",
    },
    logoImg: {
      width: 150,
      // float: "right",
      //  marginLeft: 20,
      borderRadius: 5,
      // height: "100px"
    },
    loginBtn: {
      textTransform: "none",
      // color: "rgb(35,35,35)",
      "&:hover": {
        backgroundColor: "#EF7000",
      },
    },
  })
);
function LoginPage() {
  // const LoginPage: React.FC<WithLastLocationProps> = () => {
  const lastLocation = useLastLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [remember, setRemember] = useState(true);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = React.useState(false);
  const [saveUrl, setSaveUrl] = React.useState(document.referrer);
  const [jobRole, setJobRole] = React.useState("");
  const [roleArr, setRoleArr] = React.useState([]);
  const [roleStorage, setRoleStorage] = React.useState("");

  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const global_data_common = useSelector((state: any) => state.commonReducer);

  const [showPassword, setShowPassword]: any = React.useState(false);
  const globaluserData = useSelector((state: any) => state.commonReducer);
  let copiedUrl: any = globaluserData?.copyUrlParams
    ? globaluserData?.copyUrlParams
    : "";

  // let copiedUrl: any = localStorage.getItem("copyUrlParams")
  //   ? localStorage.getItem("copyUrlParams")
  //   : "";
  const { slug } = useParams<{ slug: string }>();

  // const { slug } = params;

  const handleChange = (event: any) => {
    setRemember(event.target.checked);
  };
  const setInputState = (inputStateValue: any, inputId: any) => {
    inputId === "Username" && setUserName(inputStateValue);
    if (inputId === "Password") {
      setPassword(inputStateValue);
    }
  };
  const movePreviousPage = () => {
    history.goBack();
  };
  const login = (e: any) => {
    e.preventDefault();
    var flag = true;
    if (username === "") {
      flag = false;
    } else if (password === "") {
      flag = false;
    }

    if (flag) {
      setSubmitClickFlag(false);
      var cryptoPassword = CryptoJS.AES.encrypt(password, "acuity").toString();
      AuthClient.login({ email: username, password: password })
        .then((response: any) => {
          loginSuccess(response);
        })
        .catch((error) => {
          dispatch(showSnackbar("error", error.errors));
        });
    } else {
      setSubmitClickFlag(true);
    }
    // Post_API({ email: username, password: password }, api_url.login, loginSuccess, true);
  };
  const loginSuccess = useCallback(
    (response: any) => {
      if (!response.success) {
        alert("Something went wrong, please try again !!!");
      } else {
        dispatch({
          type: DELETE_DATA,
        });
        ////////////////////////////NEW CODE////////////////////////////////////
        dispatch({
          type: GLOBAL_DATA,
          payload: {
            userData: response.data,
            accessLevel: response.data.access_level,
            profile_logo: response.data.logo_url,
            role: response?.data?.role[0],
            employee_id: response.data.employee_id,
            organisation_id: response.data.organisation_id,
            organisation_name: response.data.organisation_name,
            ...fetchLevelAccess(response?.data?.role[0], response.data),
          },
        });
        if (response?.data?.role[0] === "admin") {
          dispatch({ type: ACCESS_PERMISSION, payload: "" });
        }
        if (
          response.data.job_roles.length > 1 &&
          response.data.role[0] !== "partner"
        ) {
          setOpen(true);
          setRoleArr(response.data.job_roles);
        } else {
          response.data.job_roles.length === 1 &&
            dispatch({
              type: GLOBAL_DATA,
              payload: { jobRole: response.data.job_roles[0] },
            });
          if (
            copiedUrl !== undefined &&
            localStorage.getItem("copyUrlParams") &&
            (copiedUrl.includes("coaching_request_form") ||
              copiedUrl.includes("coaching_agreement_form") ||
              copiedUrl.includes("evaluation_form"))
          ) {
            // history.goBack();
            const urlArr = copiedUrl?.split("/");
            history.push(`/${urlArr[3]}/${urlArr[4]}`);
          }
          handerRoutes(response);
        }
        sessionStorage.setItem("name", response.data.name);
        localStorage.setItem("name", response.data.name);

        ////////////////////////////NEW CODE////////////////////////////////////
        // dispatch({
        //   type: GLOBAL_DATA,
        //   payload: {
        //     role: response.data.role[0],
        //     accessLevel: response.data.access_level,
        //   },
        // });
        // dispatch({
        //   type: GLOBAL_DATA,
        //   payload: {
        //     profile_logo: response.data.logo_url,
        //   },
        // });
        // response.data.role[0] === "admin" &&
        //   dispatch({ type: ACCESS_PERMISSION, payload: "" });
        // sessionStorage.setItem("role", response.data.role[0]);
        // setRoleStorage(response.data.role[0]);
        // sessionStorage.setItem("employee_id", response.data.employee_id);
        // sessionStorage.setItem("organisation_id", response.data.organisation_id);
        // localStorage.setItem("organisation_id", response.data.organisation_id);
        // sessionStorage.setItem(
        //   "organisation_name",
        //   response.data.organisation_name
        // );
        // sessionStorage.setItem("name", response.data.name);
        // // sessionStorage.setItem("profile_logo", )
        // localStorage.setItem("name", response.data.name);
        // if (
        //   response.data.job_roles.length > 1 &&
        //   response.data.role[0] !== "partner"
        // ) {
        //   setOpen(true);
        //   setRoleArr(roleArr.concat(response.data.job_roles));
        // } else {
        //   response.data.job_roles.length === 1 &&
        //     dispatch({
        //       type: GLOBAL_DATA,
        //       payload: { jobRole: response.data.job_roles[0] },
        //     });
        //   localStorage.setItem("jobRole", response.data.job_roles[0]);
        //   if (
        //     copiedUrl !== undefined &&
        //     localStorage.getItem("copyUrlParams") &&
        //     (copiedUrl.includes("coaching_request_form") ||
        //       copiedUrl.includes("coaching_agreement_form") ||
        //       copiedUrl.includes("evaluation_form"))
        //   ) {
        //     // history.goBack();
        //     const urlArr = copiedUrl?.split("/");
        //     history.push(`/${urlArr[3]}/${urlArr[4]}`);
        //     console.log(
        //       "employee_id :>> ",
        //       sessionStorage.getItem("employee_id")
        //     );
        //   }
        //   global_data_common.role == "partner" && history.push("/CoachHome");
        //   response.data.role[0] == "admin" && history.push("/ManageInfo");
        //   response.data.role[0] == "partner" && history.push("/CoachHome");
        //   response.data.role[0] == "employee" &&
        //     !copiedUrl &&
        //     history.push("/OrganizationHome");
        //   !copiedUrl &&
        //     response.data.role[0] == "finance_admin" &&
        //     history.push("/FinanceAdminHome");
        //   if (
        //     response.data.role[0] == "employee" &&
        //     (response.data.role.includes("Internal Coach") ||
        //       response.data.role.includes("External Coach"))
        //   ) {
        //     !copiedUrl && history.push("/CoachHome");
        //   }
        // }
      }
    },
    [globaluserData]
  );

  const handerRoutes = useCallback(
    (response) => {
      response?.data?.role.includes("partner") && history.push("/CoachHome");
      response?.data?.role.includes("admin") && history.push("/ManageInfo");
      response?.data?.role.includes("employee") &&
        !copiedUrl &&
        history.push("/OrganizationHome");
      !copiedUrl &&
        response.data.role[0] === "finance_admin" &&
        history.push("/FinanceAdminHome");
      if (
        response.data.role[0] === "employee" &&
        (response.data.role.includes("Internal Coach") ||
          response.data.role.includes("External Coach"))
      ) {
        !copiedUrl && history.push("/CoachHome");
      }
    },
    [global_data_common]
  );

  const handleClose = () => {
    setOpen(false);
    dispatch({ type: GLOBAL_DATA, payload: { jobRole: jobRole } });
    global_data_common.role === "partner" && history.push("/CoachHome");
    global_data_common.role === "employee" && history.push("/OrganizationHome");
    if (
      global_data_common.role === "employee" &&
      (jobRole === "Internal Coach" || jobRole === "External Coach")
    ) {
      history.push("/CoachHome");
    }
    // assignments/current_job_role?current_role
  };
  const handleContinue = () => {
    DataService.getDirectData(
      `assignments/current_job_role?current_role=${jobRole}`
    )
      .then((res) => {
        if (res.success) {
          handleClose();
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", ["Something went wrong"]));
      });
  };
  const handleRoleChange = (value: string) => {
    setJobRole(value);
    sessionStorage.setItem("jobRole", value);

    const accessLevel =
      global_data_common?.userData?.job_role_access_level?.find(
        (item: any) => item.job_role === value
      )?.access_level;
    dispatch({
      type: GLOBAL_DATA,
      payload: { jobRole: value, accessLevel: accessLevel },
    });
    dispatch({
      type: ACCESS_PERMISSION,
      payload: accessLevel ? accessLevel.toLowerCase() : "",
    });
    // if (
    //   window.document.referrer === copiedUrl &&
    //   copiedUrl !== undefined &&
    //   localStorage.getItem("copyUrlParams") &&
    //   copiedUrl.includes("coaching_request_form")
    // ) {
    //   history.goBack();
    // }
    if (
      copiedUrl !== undefined &&
      localStorage.getItem("copyUrlParams") &&
      (copiedUrl.includes("coaching_request_form") ||
        copiedUrl.includes("coaching_agreement_form") ||
        copiedUrl.includes("evaluation_form"))
    ) {
      // history.goBack();
      const urlArr = copiedUrl?.split("/");
      history.push(`/${urlArr[3]}/${urlArr[4]}`);
    }
  };
  const handleChangeP = (prop: any) => (event: any) => {
    setPassword(event.target.value);
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };
  const logout = () => {
    queryClient.clear();
    // sessionStorage.clear();
    sessionStorage.removeItem("authorization_headers");
    sessionStorage.removeItem("jobRole");
    dispatch({ type: DELETE_DATA });
    setOpen(false);
  };
  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={login}
      onKeyPress={(e) => {
        e.key === "Enter" && login(e);
      }}
    >
      <Grid container direction="row" justify="center">
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <img src={logo} alt="Acuity" className={classes.logoImg} />
        </Grid>
        {
          localStorage.getItem("name") != null ? (
            // <React.Fragment>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography variant="subtitle1">
                <Box fontWeight="fontWeightBold" mt={2}>
                  Welcome back {localStorage.getItem("name")}
                </Box>
              </Typography>
            </Grid>
          ) : (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography variant="subtitle1">
                <Box fontWeight="fontWeightBold" mt={2}>
                  Welcome to aimio, the Acuity Coaching client portal that you
                  will have access to as an Acuity Coaching client.
                </Box>
              </Typography>
            </Grid>
          )
          // </React.Fragment>
        }
        <Grid item xs={12} style={{ marginTop: 30, marginBottom: 20 }}>
          <CustomInput
            id="Username"
            placeholder="Username"
            autoFocus
            name="Username"
            helperText={
              submitClickFlag && username === "" ? "Please enter username." : ""
            }
            error={submitClickFlag && username === "" ? true : false}
            parentcall={setInputState}
          />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 20 }}>
          <Input
            style={{ width: "100%" }}
            id="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            inputProps={{
              style: { fontSize: "16px", fontFamily: "Open Sans" },
            }}
            onChange={handleChangeP("password")}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <Typography
            variant="h2"
            color="secondary"
            style={{ textAlign: "right" }}
          >
            <Link
              className={classes.textSecondary}
              to={{
                pathname: "/auth/forgotPassword",
                state: { subPage: "forgotPassword" },
              }}
            >
              {" "}
              Forgot password?{" "}
            </Link>
          </Typography>
        </Grid>
        <Grid
          item
          xs={3}
          justify="center"
          style={{ marginTop: 20, textAlign: "center" }}
        >
          <Button
            variant="contained"
            id="myBtn"
            color="secondary"
            type="submit"
            style={{ textTransform: "none" }}
            // className={classes.loginBtn}
          >
            {" "}
            Login
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h2"
            // className="textSecondary"
            style={{
              textAlign: "center",
              marginTop: 20,
              textDecoration: "underline",
            }}
          >
            <Link
              // color="secondary"
              className={classes.textSecondary}
              to={{
                pathname: "/auth/register",
                state: { subPage: "register" },
              }}
            >
              {" "}
              New user? Create new account
            </Link>
          </Typography>
        </Grid>
      </Grid>
      {
        <Modal
          disableBackdropClick
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={`${classes.paper} ${classes.modalInner}`}>
              <Grid container>
                <Grid item xs={2}></Grid>
                <Grid item xs={8}>
                  <Typography
                    variant="h1"
                    style={{
                      color: "#4D4F5C",
                      marginTop: 20,
                      textAlign: "center",
                    }}
                  >
                    Choose Role
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      height: "100%",
                      justifyContent: "flex-end",
                      alignItems: "flex-start",
                    }}
                  >
                    <IconButton style={{ padding: 0 }} onClick={logout}>
                      <CloseIcon />
                    </IconButton>
                  </div>
                </Grid>
              </Grid>

              <FormControl
                component="fieldset"
                style={{ marginTop: 20, marginBottom: 20 }}
              >
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={jobRole}
                  onChange={(event) =>
                    handleRoleChange((event.target as HTMLInputElement).value)
                  }
                >
                  {roleArr.map((option) => {
                    return (
                      <FormControlLabel
                        // className={classes.formLabel}
                        value={option}
                        control={<Radio />}
                        label={
                          <Typography variant="subtitle1">{option}</Typography>
                        }
                      />
                    );
                  })}
                </RadioGroup>
              </FormControl>
              <div style={{ textAlign: "center" }}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginBottom: "12px",
                    color: "#EF7000",
                  }}
                >
                  *Please select a role to continue
                </Typography>
                <Button
                  variant="outlined"
                  onClick={handleContinue}
                  disabled={!jobRole}
                >
                  {" "}
                  Continue
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
      }
    </form>
  );
}

export default LoginPage;
